export default __webpack_public_path__ + "static/media/personA.62226a72.svg";